// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementOnReachHistoryConfig = {
    title: 'chart.facebook.avg_engagement_rate_on_reach_history',
    tooltip: 'chart.facebook.tooltip_avg_engagement_rate_on_reach_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.facebook.avg_engagement_rate_on_reach_history_name'
    },
    id: 'average_engagement_on_reach_history',
    social: FACEBOOK,
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
